import type { ApiClient } from './client';

// ANX-072 — Отделы (departments). Справочник на уровне организации (tenant).
// List — любой operator; mutate — admin (RBAC на backend).

export interface Department {
  id: string;
  name: string;
  position: number;
}

interface RawList {
  departments: Department[];
}

export async function listDepartments(client: ApiClient): Promise<Department[]> {
  const raw = await client.request<RawList>('/api/v1/departments');
  return raw.departments;
}

export async function createDepartment(
  client: ApiClient,
  input: { name: string },
): Promise<Department> {
  return client.request<Department>('/api/v1/departments', {
    method: 'POST',
    json: input,
  });
}

export async function updateDepartment(
  client: ApiClient,
  id: string,
  input: { name: string },
): Promise<Department> {
  return client.request<Department>(`/api/v1/departments/${id}`, {
    method: 'PATCH',
    json: input,
  });
}

export async function deleteDepartment(client: ApiClient, id: string): Promise<void> {
  await client.request<void>(`/api/v1/departments/${id}`, { method: 'DELETE' });
}
